import { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { backtestApi } from '../lib/apiClient.js';

const TERMINAL = new Set(['complete', 'failed', 'error', 'cancelled']);

export default function JobCenter() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [error, setError] = useState('');
  const [expanded, setExpanded] = useState(false);
  const epoch = useRef(0);
  const refresh = useCallback(async () => {
    const requestEpoch = epoch.current;
    if (!user) { setJobs([]); return; }
    try { const rows = await backtestApi.history(); if (epoch.current === requestEpoch) { setJobs(rows); setError(''); } }
    catch { if (epoch.current === requestEpoch) setError('Job status is temporarily unavailable. Submitted jobs continue on the server.'); }
  }, [user]);
  useEffect(() => {
    setJobs([]);
    let alive = true;
    const update = () => { if (alive) refresh(); };
    const submitted = () => { setExpanded(true); update(); };
    update();
    const timer = setInterval(update, 5000);
    window.addEventListener('alphaqap:job-submitted', submitted);
    return () => { alive = false; epoch.current++; clearInterval(timer); window.removeEventListener('alphaqap:job-submitted', submitted); };
  }, [refresh]);
  const active = jobs.filter((job) => job.status && !TERMINAL.has(job.status));
  return <section className="aq-job-center" aria-label="Background jobs">
    <button type="button" onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>
      My jobs · {active.length ? `${active.length} in progress` : 'No active runs'}
    </button>
    {active.length > 0 && <span role="status" aria-live="polite"> Runs continue while you navigate.</span>}
    {error && <p role="alert">{error}</p>}
    {expanded && <ul>{jobs.slice(0, 15).map((job) => <li key={job.jobId}>
      <Link to={`/app/backtest?run=${encodeURIComponent(job.jobId)}`}>{job.mode || 'Backtest'} · {job.status || 'historical'}</Link>
      <span> · {new Date(job.savedAt).toLocaleString()}</span>
      {job.status === 'queued' && <button type="button" onClick={async () => {
        try { await backtestApi.cancel(job.jobId); await refresh(); }
        catch (err) { setError(err.message); }
      }}>Cancel queued run</button>}
    </li>)}</ul>}
  </section>;
}
